<template>
  <a :href="$routes.HOME" class="logo-wrapper">
    <img
      v-if="logo && logo.logo.url"
      :src="logo.logo.url"
      alt="Logo"
      class="logo"
    />
  </a>
</template>

<script>
import { cmsGet } from '@/utils/cms';

export default {
  name: 'Logo',

  data() {
    return {
      logo: null
    };
  },

  async created() {
    try {
      const { data } = await cmsGet('/logo', {
        locale: this.$routeLocale
      });
      this.logo = data;
    } catch (error) {
      console.log(error);
    }
  }
};
</script>

<style lang="scss" scoped>
.logo-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
}

.logo {
  height: 64%;

  @media ($desktop) {
    height: 55%;
  }
}
</style>
